import { toast } from "react-toastify";

import {
  ensureSncrAuthPopupListener,
  notifySncrAuthPopup,
  openSncrAuthPopup,
} from "../helpers/authPopup";
import {
  clearAccessToken,
  getAccessToken,
  getExchangeLock,
  setAccessToken,
  setExchangeLock,
  setLastAuthResult,
} from "../helpers/storage";
import {
  buildClientUrl,
  clearSessionIdFromUrl,
  extractSessionId,
} from "../helpers/url";
import { fetchSncrAccessToken, getSncrApiUrl } from "../requests/sncrClient";

const inflightExchanges = new Map<string, Promise<boolean>>();

export { getSncrApiUrl };

export function getSncrAccessToken(): string | null {
  return getAccessToken();
}

export function clearSncrAccessToken(): void {
  clearAccessToken();
}

export function isSncrAuthenticated(): boolean {
  const token = getAccessToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function loginWithGovBr(): void {
  const loginUrl = `${getSncrApiUrl()}/auth/login?client_url=${encodeURIComponent(buildClientUrl())}`;
  // Listener antes do open: a aba atual continua aqui e recebe o token no fim.
  ensureSncrAuthPopupListener();
  const popup = openSncrAuthPopup(loginUrl);
  if (!popup) {
    toast.error("Permita pop-ups do navegador para conectar ao SNCR.");
  }
}

async function exchangeToken(sessionId: string): Promise<void> {
  const data = await fetchSncrAccessToken(sessionId);

  if (!data.access_token) {
    throw new Error("SNCR token response missing access_token");
  }

  setAccessToken(data.access_token);
}

export async function processSncrCallback(): Promise<boolean> {
  const sessionId = extractSessionId();
  if (!sessionId) return false;

  const lock = getExchangeLock(sessionId);
  if (lock === "done") {
    clearSessionIdFromUrl();
    return Boolean(getAccessToken());
  }
  if (lock === "error") {
    clearSessionIdFromUrl();
    return false;
  }

  const inflight = inflightExchanges.get(sessionId);
  if (inflight) return inflight;

  setExchangeLock(sessionId, "pending");

  const promise = (async () => {
    try {
      await exchangeToken(sessionId);
      setExchangeLock(sessionId, "done");
      setLastAuthResult("success");
      clearSessionIdFromUrl();
      notifySncrAuthPopup("success");
      return true;
    } catch (error) {
      setExchangeLock(sessionId, "error");
      setLastAuthResult("error");
      clearSessionIdFromUrl();
      notifySncrAuthPopup("error");
      console.error("[SNCR] Callback de autenticação falhou:", error);
      throw error;
    } finally {
      inflightExchanges.delete(sessionId);
    }
  })();

  inflightExchanges.set(sessionId, promise);
  return promise;
}

export function bootstrapSncrAuth(): void {
  void processSncrCallback().catch(() => {

  });
}
